const SHOP_PAY_TERMS_TAG = 'shopify-payment-terms';

export const updateProductVariantInShopPayTerms = (shopPayWrapperSelector) => {
  const shopPayWrapperEls = document.querySelectorAll(
    `${shopPayWrapperSelector}`
  );

  shopPayWrapperEls.forEach((shopPayWrapperEl) => {
    const variantId = shopPayWrapperEl.getAttribute('data-variant-id');
    const shopPayTermsEl = shopPayWrapperEl.querySelector(
      `${SHOP_PAY_TERMS_TAG}`
    );

    if (variantId && shopPayTermsEl) {
      shopPayTermsEl.setAttribute('variant-id', variantId);
    }
  });
};
